export const CANVAS_CONFIG = {
  width: 1400,
  height: 1000,
  margin: {
    top: 10,
    right: 10,
    bottom: 60,
    left: 60
  }
};